<template>
    <ak-form-decorator
        :id="id"
        :title="title"
        :helpText="helpText"
        :error="error"
        :hasError="hasError"
        :required="required"
        :value="value"
        :locales="locales"
    >
        <span class="ak-form__prefix">
            {{prefix}}
        </span>
        <input
                type="text"
                v-model="currentValue"
                :placeholder="placeholder"
                :readonly="readOnly"
                class="ak-form__control ak-form__control--prefix"
                :class="{
                    'ak-form__control--has-value': currentValue,
                }"
                v-on="$currentListeners"
        >

        <slot name="popover"></slot>
    </ak-form-decorator>

</template>

<script>
import FormElementMixin from "../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/components/form/mixins/FormElementMixin";

export default {
    name: 'ak-percentage',
    props: {
        prefix: {
            type: String,
            default: '€'
        }
    },
    mixins: [FormElementMixin],
    data() {
        return {
            modifiedValue: 0,
        };
    },
    computed: {
        currentValue: {
            get() {
                return this.modifiedValue / 100;
            },
            set(e) {
                this.modifiedValue = e * 100;
                this.$emit('input', this.modifiedValue)
            }
        }
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value * 100)
        }
    },
    created() {
        this.modifiedValue = this.value;
    }
}
</script>
